import axios from "axios";

axios.defaults.headers = {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
};

const ContentNativeAdvertising = () => ({
    reload(pageId, blockId) {
        if (pageId <= 0 || blockId === '') {
            return;
        }

        axios.get('/wp-json/ilj-theme/v1/conaad', { params: { pid: pageId, bid: blockId } })
            .then(resp => {
                const elem = document.createElement('div');
                elem.innerHTML = resp.data.rendered_block.trim();

                const inside = elem.querySelector('.CoNaAd');
                this.$el.innerHTML = inside.innerHTML;
            })
            .catch(e => { return; });
    }
});

export default ContentNativeAdvertising;